import React from 'react';

export const SvgIconHamburger = () => (
    <div className="svg-icon svg-icon--hamburger">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 13">
            <g className="icon-paths" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <path d="M1.396.5h18.277M1.396 6.5h18.277M1.396 12.5h18.277" />
            </g>
        </svg>
    </div>
);
